import type { TagColor } from './tags';
import type { ProjectBadgeColor } from '@flowqa/shared';

export type TagBadgeColour = TagColor & ProjectBadgeColor;
export type TagBadgeChipColourKey =
  | 'grey'
  | 'green'
  | 'red'
  | 'yellow'
  | 'brown'
  | 'blue'
  | 'purple'
  | 'teal';

export const defaultTagBadgeColour: TagBadgeColour = 'teal';

export const tagBadgeColourOptions: Array<{ value: TagBadgeColour; swatch: string }> = [
  { value: 'neutral', swatch: '#59616d' },
  { value: 'green', swatch: '#2b6135' },
  { value: 'orange', swatch: '#704b1d' },
  { value: 'red', swatch: '#713d39' },
  { value: 'blue', swatch: '#2d5b72' },
  { value: 'purple', swatch: '#554278' },
  { value: 'teal', swatch: '#005d5a' },
  { value: 'brown', swatch: '#554842' },
];

const tagBadgeChipColourByValue = {
  neutral: 'grey',
  green: 'green',
  orange: 'yellow',
  red: 'red',
  blue: 'blue',
  purple: 'purple',
  teal: 'teal',
  brown: 'brown',
} as const satisfies Record<TagBadgeColour, TagBadgeChipColourKey>;

export const resolveTagBadgeColourSwatch = (colour: TagBadgeColour): string =>
  tagBadgeColourOptions.find((option) => option.value === colour)?.swatch ??
  tagBadgeColourOptions.find((option) => option.value === defaultTagBadgeColour)?.swatch ??
  '#006361';

export const resolveTagBadgeChipColourKey = (colour: TagBadgeColour): TagBadgeChipColourKey =>
  tagBadgeChipColourByValue[colour];

export const isTagBadgeColour = (value: string): value is TagBadgeColour =>
  tagBadgeColourOptions.some((option) => option.value === value);
